/**
 * Created by vladislav on 13.07.20.
 */

const TileShuffleBooster = function (id) {
    Booster.call(this, id);
};

TileShuffleBooster.prototype = Object.create(Booster.prototype);
TileShuffleBooster.prototype.constructor = TileShuffleBooster;

TileShuffleBooster.prototype.onGameStarted = function () {
    Game.currentGame.log.on("change", this.updateState.bind(this));
    Game.currentGame.pagination.on("changePage", this.updateState.bind(this));
};

TileShuffleBooster.prototype.updateState = function () {
    if (Game.currentGame.table.cards.length <= 1) {
        this.onDisableListener();
    } else {
        this.onEnableListener();
    }
};

TileShuffleBooster.prototype.onExecute = function () {
    Game.currentGame.table.shuffle();
};
